import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function PermissionRoute({ perm, children }) {
  const { isAuthenticated, hasAnyPermission } = useAuth();

  if (!isAuthenticated) return <Navigate to="/" replace />;
  if (!hasAnyPermission(perm)) return <Navigate to="/home" replace />;

  return children;
}
